import React from "react";
import { renderContentProps } from "./types";
import { Attachment } from "types/conversationInbox";
import { MessageMedia } from "../../components/message-attachments";
import { cn } from "@/lib/utils";

export const IgStoryMention = (
  props: renderContentProps
): JSX.Element | null => {
  const { story } = props;

  if (!story) return null;

  const media: Attachment = {
    type: story.type,
    payload: {
      url: story.url,
    },
  };

  return <MessageMedia {...props} media={media} portraitMedia />;
};

interface StoryMentionIconBackgroundProps {
  disabled?: boolean;
  children?: React.ReactNode;
}

export const StoryMentionIconBackground = ({
  disabled,
  children,
}: StoryMentionIconBackgroundProps) => (
  <div
    className={cn(
      "absolute bottom-0",
      disabled ? "right-[135px]" : "-right-[35px]"
    )}
  >
    {children}
  </div>
);
